module.exports = __webpack_public_path__ + "static/media/evier.0604b38e.pdf";